import { closeChatOverlayBeforeMemberNavigation } from "@utils/member/navigateToMemberPricingPage";

export const navigateAfterClosingChat = (
  router: { push: (href: string) => void },
  href: string,
) => {
  closeChatOverlayBeforeMemberNavigation(() => {
    router.push(href);
  });
};
